import "../style/page/ProductOrderpage.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
  appoinmentreshedule,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { pharmacyrequest, pharmacytrackorder } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AppoinmentReschedule from "../form/appoinmentreschedule";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

function PharmacyRequest(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const formpage = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const [trackorderidp, settrackorderidp] = useState("");
  const [trackorderstatep, settrackorderstatep] = useState(false);
  const [id, setid] = useState("");
  const [popup, setpopup] = useState(false);
  const [disvalue, setdisvalue] = useState("");

  const locationid = useSelector(
    (state) => state.counter.loginuser_location_id
  );
  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: pharmacyrequest,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            sample_invoice_requested: "True",
            bill_request_given: "False",
            proceed_payment: "False",
            invoice_given: "pharma_request",
            order_list: "false",
            deliveryType: "false",
            status: "r_cancel",
            branch: branches,
          },
        })
          .then((res) => {
            props.loaderchange("false");

            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data.data);
          })
          .catch((error) => {
            props.loaderchange("false");

            console.log(error);
          });
      }
    } else {
      props.loaderchange("true");

      axios({
        method: "get",
        url: pharmacyrequest,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          sample_invoice_requested: "True",
          bill_request_given: "False",
          proceed_payment: "False",
          invoice_given: "pharma_request",
          order_list: "false",
          deliveryType: "false",
          status: "r_cancel",
          branch: branches,
        },
      })
        .then((res) => {
          props.loaderchange("false");

          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data.data);
        })
        .catch((error) => {
          props.loaderchange("false");

          console.log(error);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, productstate, popup, branches]);

  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id));
    dispatch(productorder("Edit"));
    formpage("/PharmacyRequestForm");
  };

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original, "dfjsfkjshk");
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id}
              >
                {row.row.original.id}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Created date",
        accessor: "",

        Cell: (row) => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {String(row.row.original.patient.p_uhid)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      // {
      //   Header: "Need Prescription",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={
      //             row.row.original.need_prescription == false ? "No" : "Yes"
      //           }
      //         >
      //           {row.row.original.need_prescription == false ? "No" : "Yes"}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "No Prescription",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.no_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.no_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },

      // {
      //   Header: "Total Amount",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.total_amount}
      //         >
      //           {parseFloat(row.row.original.total_amount).toFixed(2)!="NaN"?parseFloat(row.row.original.total_amount).toFixed(2):"--"}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Location Range",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original, "address");
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.address.location_range == null
                    ? ""
                    : row.row.original.address.location_range
                }
              >
                {row.row.original.address.location_range != null
                  ? row.row.original.address.location_range + " Km"
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => {
                    dropdownhandlechange(row.row.original.id, e);
                    e.stopPropagation();
                  }}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  onClick={(e) => {
                    setid(row.row.original.id);
                    dispatch(productorder("Edit2"));
                  }}
                >
                  <i class="bi bi-trash3"></i> Cancel
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };

  const newusercreate = () => {
    props.loaderchange("true");

    axios({
      method: "put",
      url: pharmacyrequest + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      data: {
        status: "Cancel",
        c_description: disvalue,
      },
    })
      .then((res) => {
        props.loaderchange("false");

        console.log(res);
        setpopup(false);
        dispatch(productorder(""));
      })
      .catch((error) => {
        props.loaderchange("false");

        console.log(error);
      });
  };

  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Pharmacy Request</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Pharmacy Request</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}>
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    stateid={"1"}
                    settrackorderidp={settrackorderidp}
                    settrackorderstatep={settrackorderstatep}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>

      {productstate == "Edit2" && (
        <div className="adminform">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content1">
              <div class="modal-header">
                <h5 class="modal-title">Pharmacy Request</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    dispatch(productorder(""));
                  }}
                >
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="modal-body">
                <div className="maincontainer-BaseTimeForm">
                  <div className="parent-BaseTimeForm">
                    <div className="create-BaseTimeForm card">
                      <form
                        style={{ padding: "0rem 0rem 0rem 0rem" }}
                        className="formspace"
                        onSubmit={handleSubmit}
                      >
                        <div class="form-group col-md-12 p-1 m-0 datepic">
                          <label for="validationCustom04" class="form-label">
                            Description
                          </label>
                          <textarea
                            type="textarea"
                            class="form-control"
                            id="validationCustom01"
                            name="description"
                            value={disvalue}
                            style={{ resize: "none" }}
                            onChange={(e) => {
                              setdisvalue(e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            rows="4"
                            required
                          ></textarea>

                          <p style={{ fontSize: "12px", color: "red" }}>
                            {disvalue.length > 0
                              ? ""
                              : "description cannot be empty"}
                          </p>
                        </div>
                        <div
                          class="form-row"
                          style={{
                            display: "flex",
                            flexFlow: "row wrap",
                            placeContent: "center space-between",
                            alignItems: "center",
                          }}
                        >
                          <div class="form-group col-md-12 pb-3 pt-4 m-0">
                            <button
                              type="submit"
                              class="btn btn-primary  create"
                              onClick={(e) => {
                                if (disvalue.length > 0) {
                                  setpopup(true);
                                }
                              }}
                              disabled={!alert ? true : false}
                            >
                              Cancel Pharmacy Request
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button
                  class="close"
                  onClick={(e) => {
                    setpopup(false);
                  }}
                >
                  ✖
                </button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>
                  Do You Want to Cancel the Pharmacy Request?
                </p>
                <div style={{ display: "flex" }}>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => newusercreate()}
                  >
                    Yes!
                  </button>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => setpopup(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default PharmacyRequest;
